export default "__VITE_ASSET__BjbdR9KY__"